import * as React from "react"
import type { SVGProps } from "react"
const SvgUnlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 22.71q-.82 0-1.41-.58A2 2 0 0 1 4 20.7v-10q0-.83.59-1.4A2 2 0 0 1 6 8.7h9v-2q0-1.25-.87-2.12A3 3 0 0 0 12 3.7q-1.05 0-1.84.64T9.1 5.94a1 1 0 0 1-.41.56 1.2 1.2 0 0 1-.69.21 1 1 0 0 1-.71-.27.7.7 0 0 1-.22-.65 5.04 5.04 0 0 1 8.47-2.61A4.8 4.8 0 0 1 17 6.7v2h1q.83 0 1.41.6.6.57.59 1.4v10q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h12v-10H6zm6-3q.83 0 1.41-.58.6-.6.59-1.42c-.01-.82-.2-1.02-.59-1.4a2 2 0 0 0-1.41-.6q-.83 0-1.41.6a2 2 0 0 0-.59 1.4q0 .82.59 1.42.58.58 1.41.58" />
  </svg>
)
export default SvgUnlock
